<template>
  <div class="expansion-login">
    <common-bg-plate>
      <div class="light-area"></div>
      <div class="logo"></div>
      <div class="instruction">
        <instruction-btn :id="instruction.expansion.id" tool-tip-placement="left" :instruction-info="instruction.expansion.instructionInfo"></instruction-btn>
      </div>
      <div class="login-box">
        <el-form
          ref="dataForm"
          :model="dataForm"
          :rules="rules"
          :label-width="`${adaptationVars.formLabelWidth}px`"
          label-position="top"
        >
          <el-form-item label="区块链ID" prop="chainId">
            <el-select v-model="dataForm.chainId" clearable placeholder="" @change="handleSelect">
              <el-option
                v-for="(item, i) in options"
                :key="item.ChainId + i"
                :label="item.ChainName"
                :value="item.ChainId"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="用户名称" prop="certId">
            <el-select v-model="dataForm.certId" clearable placeholder="">
              <el-option
                v-for="(item, i) in userData"
                :key="item.id + i"
                :label="item.UserName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="login-btn">
          <el-button type="primary" @click="handleLogin()">登录</el-button>
        </div>
      </div>
    </common-bg-plate>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import instruction from '@/instruction/index'
export default {
  name: 'Login',
  components: {},
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      dataForm: {
        chainId: '',
        certId: null
      },
      userData: [],
      options: [],
      rules: {
        chainId: [{ required: true, message: '请选择区块链', trigger: 'change' }],
        certId: [{ required: true, message: '请选择用户', trigger: 'change' }]
      },
      adaptationVars: {
        formLabelWidth: 100
      },
      instruction
    }
  },

  mounted() {
    this.getOptions()
  },
  methods: {
    handleLogin() {
      let params = {
        chainId: this.dataForm.chainId,
        certId: this.dataForm.certId
      }
      this.$apis.expansionDemo
        .getUserInfo(params)
        .then(res => {
          if (res) {
            this.$router.push({
              name: 'expansionDemo'
            })
            this.$store.commit('balanceChange', res.data.balance)
            localStorage.setItem('cbaas_expansion_user_info', JSON.stringify(res.data))
          }
        })
        .catch(err => {
          this.disabled = false
        })
    },
    getOptions() {
      let param = {
        offset: 0,
        limit: 50
      }
      this.$apis.home.getSubscribeQueryList(param).then(res => {
        if (res.data && res.data.items) {
          this.options = res.data.items
        }
      })
    },
    handleSelect() {
      this.getUserData()
    },
    getUserData() {
      let params = { chainId: this.dataForm.chainId }
      this.$apis.expansionDemo
        .getUser(params)
        .then(res => {
          if (res) {
            this.userData = res.data
          }
        })
        .catch(err => {
          this.disabled = false
        })
    }
  }
}
</script>

<style scoped lang="scss">

@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('expansion-login', (
  --bg-plate-border-color: var(--expansion-login-common-bg-plate-border-color),
  --light-area-display: block,
  --expansion-login-common-bg-plate-background-1: #313e6b 0.64%,
  --expansion-login-common-bg-plate-background-2: #050e30 100%,
  --bg-plate-background: linear-gradient(249deg, #313e6b 0.64%, #050e30 100%),
  --expansion-login-common-bg-plate-border-color: #313e6b,
  --expansion-login-light-area-background-color: rgba(67, 146, 255, 0.68)
), (
  --bg-plate-border-color: var(--base-color-white),
  --light-area-display: none,
  --expansion-login-common-bg-plate-background-1: #45C2FF 0.64%,
  --expansion-login-common-bg-plate-background-2: #EBEBEB 100%,
  --bg-plate-background: var(--base-color-white),
  --expansion-login-common-bg-plate-border-color: #45C2FF,
  --expansion-login-light-area-background-color: rgba(126, 214, 255, 0.68)
));
.expansion-login {
  @include adaptation(
    (
      --common-gap-32: 32px,
      --expansion-login-border-width: 1px,
      --expansion-login-light-area-top: -396px,
      --expansion-login-light-area-right: -479px,
      --expansion-login-light-area-width: 958px,
      --expansion-login-light-area-height: 793px,
      --expansion-login-light-area-border-radius: 958px,
      --expansion-login-light-area-filter-size: 250px,
      --expansion-login-logo-width: 483px,
      --expansion-login-logo-height: 483px,
      --expansion-login-login-box-height: 230px,
      --expansion-login-login-box-width: 278px,
      --expansion-login-login-box-padding: 16px 16px,
      --expansion-login-login-box-right: 202px,
      --expansion-login-login-box-form-label-height: 17px,
      --expansion-login-login-box-form-label-margin-bottom: 8px,
      --expansion-login-login-box-login-btn-padding-top: 4px
    )
  );
  --expansion-login-common-bg-plate-min-height: var(--base-main-router-body-avaliable-height);
  --expansion-login-logo-top: calc(
    (var(--base-main-router-body-avaliable-height) - var(--expansion-login-logo-height)) / 3
  );
  --expansion-login-login-box-top: calc(
    var(--expansion-login-logo-top) +
      (var(--expansion-login-logo-height) - var(--expansion-login-login-box-height)) / 2
  );
  .common-bg-plate {
    min-height: var(--expansion-login-common-bg-plate-min-height);
    background: var(--bg-plate-background);
    border: var(--expansion-login-border-width) solid
      var(--bg-plate-border-color);
    position: relative;
    overflow: hidden;

    .light-area {
      position: absolute;
      display: var(--light-area-display);
      top: var(--expansion-login-light-area-top);
      right: var(--expansion-login-light-area-right);
      width: var(--expansion-login-light-area-width);
      height: var(--expansion-login-light-area-height);
      border-radius: var(--expansion-login-light-area-border-radius);
      background: var(--expansion-login-light-area-background-color);
      filter: blur(var(--expansion-login-light-area-filter-size));
    }

    .logo {
      width: var(--expansion-login-logo-width);
      height: var(--expansion-login-logo-height);
      position: absolute;
      left: 8%;
      top: var(--expansion-login-logo-top);
      background-image: url('~@/assets/images/expansion/expansion-logo.png');
      background-size: 100% 100%;
    }

    .instruction {
      position: absolute;
      right: var(--common-gap-32);
      top: var(--common-gap-32);
    }

    .login-box {
      position: absolute;
      height: var(--expansion-login-login-box-height);
      width: var(--expansion-login-login-box-width);
      padding: var(--expansion-login-login-box-padding);
      top: var(--expansion-login-login-box-top);
      right: var(--expansion-login-login-box-right);

      .el-form {
        .el-form-item {
          /deep/ {
            .el-select {
              width: 100%;
            }

            .el-form-item__label {
              line-height: var(--expansion-login-login-box-form-label-height);
              height: var(--expansion-login-login-box-form-label-height);
              margin-bottom: var(--expansion-login-login-box-form-label-margin-bottom);
              padding: 0;
            }
          }
        }
      }

      .login-btn {
        padding-top: var(--expansion-login-login-box-login-btn-padding-top);
        display: flex;
        flex-direction: row-reverse;
      }
    }
  }
}
</style>
